import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import routes from '../config/routes';
import { ReactComponent as InstagramIcon } from '../instagram.svg';
import '../styles/navigation.css';

function Navigation() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <nav className="navigation">
      <button
        className="hamburger"
        onClick={toggleMobileMenu}
        aria-label="Toggle menu"
      >
        {mobileMenuOpen ? '✕' : '☰'}
      </button>

      <div className={`nav-links ${mobileMenuOpen ? 'mobile-menu-open' : ''}`}>
        {routes.map((route) => (
          <Link
            key={route.path}
            to={route.path}
            className="nav-link"
            onClick={closeMobileMenu}
          >
            {route.label}
          </Link>
        ))}

        <a
          href="https://instagram.com/krishisharma"
          target="_blank"
          rel="noopener noreferrer"
          className="nav-link instagram-link"
          onClick={closeMobileMenu}
          aria-label="Instagram"
        >
          <InstagramIcon className="instagram-icon" />
        </a>
      </div>
    </nav>
  );
}

export default Navigation;
